import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

const faqs = [
  {
    q: "What happens if I need to cancel an order?",
    a: (
      <>
        We try to be honest about this. If you cancel{" "}
        <strong>before the vendor accepts</strong> your order, you get a{" "}
        <strong>full refund</strong>. Once the vendor has accepted and started
        preparing, a <strong>fair partial-refund policy</strong> applies based
        on how far along they are, shown to you plainly before you confirm
        the cancellation. Once a gift is fully prepared, it&rsquo;s yours, and
        refunds are no longer possible. No surprises, no fine print.
      </>
    ),
  },
  {
    q: "How does Liéa know what gift to recommend?",
    a: (
      <>
        When you add someone to your Circle, you tell Liéa a bit about them 
        their relationship to you, their interests, things to avoid (allergies,
        sensitivities), and the dates that matter. Liéa then matches that
        profile against the occasion and against what real local vendors near
        the recipient actually offer. The recommendation is shaped by{" "}
        <em>that person</em>, not a generic catalog.
      </>
    ),
  },
  {
    q: "Can I track my order?",
    a: (
      <>
        Yes. You&rsquo;ll see live status in the app, accepted, being
        prepared, ready, out for delivery, delivered. Important updates also
        arrive on WhatsApp, so you don&rsquo;t need to keep the app open. If
        something needs clarifying, you can message the vendor directly about
        that specific order.
      </>
    ),
  },
  {
    q: "What if the vendor can't fulfill in time?",
    a: (
      <>
        Vendors set their own minimum notice period per product and can mark
        blackout dates, so the recommendations you see already respect their
        availability. In the rare case something goes wrong after an order is
        placed, Liéa helps you switch to an alternative vendor or issues a
        refund, you&rsquo;re never left holding the problem.
      </>
    ),
  },
  {
    q: "How do I become a vendor?",
    a: (
      <>
        Head to the <a href="#for-vendors" style={{ color: "var(--liea-terracotta)" }}>For vendors</a>{" "}
        section and apply through the in-app onboarding. We&rsquo;ll review
        your shop, help you set up business hours, products, pickup locations,
        and payout details, and get you receiving real matched orders 
        typically within about a week.
      </>
    ),
  },
];

export const FAQ = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="liea-section"
      style={{ background: "var(--liea-paper)" }}
    >
      <div className="liea-container grid lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-5">
          <span className="liea-eyebrow">Questions, answered</span>
          <h2 className="mt-4 text-[36px] md:text-[48px] lg:text-[52px] leading-[1.05] tracking-tight">
            Honestly,{" "}
            <em
              style={{
                fontStyle: "italic",
                color: "var(--liea-forest)",
              }}
            >
              in our own words
            </em>
            <span style={{ color: "var(--liea-terracotta)" }}>.</span>
          </h2>
          <p
            className="mt-5 text-base md:text-lg max-w-md leading-relaxed"
            style={{ color: "var(--liea-warm-grey)" }}
          >
            The stuff most people ask before they send their first gift. If
            anything else comes up, we&rsquo;re a message away.
          </p>
        </div>

        <div className="lg:col-span-7">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`item-${i}`}
                data-testid={`faq-item-${i + 1}`}
                className="liea-faq-item border-b"
                style={{ borderColor: "rgba(149, 159, 133, 0.3)" }}
              >
                <AccordionTrigger
                  className="liea-faq-trigger py-6 text-left font-serif text-[22px] md:text-[24px] hover:no-underline"
                  style={{ color: "var(--liea-ink)" }}
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent
                  className="pb-6 text-[15px] leading-relaxed"
                  style={{ color: "var(--liea-warm-grey)" }}
                >
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
